module.exports = __webpack_public_path__ + "img/KS.5e60bf2c.png";